export default __webpack_public_path__ + "static/media/57t.f334ffcf.jpg";